module.exports = __webpack_public_path__ + "b64e9910811cdcc8df89cec2b5025a9f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/LightItalic/OpenSans-LightItalic.svg?v=1.1.0
// module id = 981
// module chunks = 0